import React, { useEffect, useState } from 'react';

// reactstrap components
import { Container } from "reactstrap";
import ProgressBar from "components/ProgressBar/StepperProgress";

// services
import { showMessage } from "../../../services/message.js";
import { api_GET } from "../../../services/api_service.js";

// views
import Identificacao from "../../Shared/Gerador/Identificacao";
import LocaisColeta from "../../Shared/Gerador/LocaisColeta";
import Documentos from "../../Shared/Documentos";
import CaracterizacaoResiduos from '../../Shared/Gerador/CaracterizacaoResiduos';

//Shared
import Residuos from "../../Shared/Gerador/Residuos";

//Context
import { useAuth } from '../../../context/auth.js';

export default function ManutencaoGeradorForm({ item, handleReturn }) {
  const {setLoading} = useAuth();

  const [protocolo, set_protocolo] = useState(item);

  //pegando os steps
  const [steps, setSteps] = useState([]);

  const [opcao, set_opcao] = useState(null);

  const [step, set_step] = useState(0);
  const handleProximoStep = (_protocolo) => {
    if (step == 3)
      showMessage("Aviso", "Operação executada com sucesso!", 'success', function () {
        handleReturn();
      });
    else {
      set_protocolo(_protocolo);
      set_step(step + 1);
    }
  }
  const handleStepAnterior = (_protocolo) => {
    set_protocolo(_protocolo)
    set_step(step - 1);
  }

  const [permiteManutencao, set_permiteManutencao] = useState(false);
  const handleVerificaPermissaoManutencao = () => {
    setLoading(true);

    api_GET('Protocolo/VerifyExistsRequeriments/' + protocolo.protocolo_Id)
      .then(result => {
        set_permiteManutencao(result.data.sucesso);
        if (!result.data.sucesso) {
          showMessage("Aviso", "Não permitida a manutenção do cadastro. " + result.data.mensagem, 'warning', null);
        }
      })
      .catch(err => showMessage("Aviso", err.message, 'error', null))
      .finally(() => setLoading(false));
  }


  useEffect(() => {
    if (item && item.setupSolicitacaoAcaoNovoCadastro.setupSolicitacao.categoria.sigla != "RGG")
      setSteps(['Identificação', 'Locais de Coleta', 'Resíduos', 'Documentação']);
    else
      setSteps(['Identificação', 'Locais de Coleta', 'Caracterização dos Residuos', 'Documentação']);

    set_opcao({
      tipoCadastro: "Protocolo",
      segmento: "Grande Gerador",
      categoria: item.setupSolicitacaoAcaoNovoCadastro.setupSolicitacao.categoria
    });

    set_protocolo(item);

    if (item)
      handleVerificaPermissaoManutencao();
  }, []);

  return (
    <>
      {opcao != null &&
        <div className="content">
          <Container className="text-center">
            <ProgressBar stepValue={step} steps={steps} />
          </Container>

          {step == 0 &&
            <Identificacao
              item={protocolo}
              opcao={opcao}
              permiteManutencao={permiteManutencao}
              handleProximoStep={handleProximoStep}
              handleReturn={handleReturn}
            />
          }

          {step == 1 &&
            <LocaisColeta
              item={protocolo}
              tipoCadastro="Protocolo"
              permiteManutencao={permiteManutencao}
              handleProximoStep={handleProximoStep}
              handleStepAnterior={handleStepAnterior}
            />
          }

          {protocolo.setupSolicitacaoAcaoNovoCadastro.setupSolicitacao.categoria.sigla != "RGG" && step == 2 &&
            <Residuos
              item={protocolo}
              tipoCadastro="Protocolo"
              permiteManutencao={permiteManutencao}
              handleProximoStep={handleProximoStep}
              handleStepAnterior={handleStepAnterior}
            />
          }

          {protocolo.setupSolicitacaoAcaoNovoCadastro.setupSolicitacao.categoria.sigla == "RGG" && step == 2 &&
            <CaracterizacaoResiduos
              item={protocolo}
              opcao={opcao}
              tipoCadastro="Protocolo"
              permiteManutencao={permiteManutencao}
              handleProximoStep={handleProximoStep}
              handleStepAnterior={handleStepAnterior}
            />
          }

          {step == 3 &&
            <Documentos
              item={protocolo}
              opcao={opcao}
              handleProximoStep={handleProximoStep}
              handleStepAnterior={handleStepAnterior}
            />}
        </div>
      }
    </>
  );
}